import { COLORS } from '../../../../../designSystem/reloaded/commons/foundations/colors';
import { RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
const LABEL_ICON_COMPONENT_PROPS = {
    color: COLORS.HOVER.color_background_hover_bg_80,
    icon: 'icon_symbols_information-in-a-circle',
    width: '24px',
    height: '24px',
}, LABEL_ICON_TOOLTIP_PROPS = {
    variant: RELOADED_VARIANTS.TooltipVariantType.REGULAR,
};
export { LABEL_ICON_COMPONENT_PROPS, LABEL_ICON_TOOLTIP_PROPS };
//# sourceMappingURL=label-icon.constants.js.map